// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "#movie .banner .slide-mask-right[data-v-7c6f47cb]{background-image:linear-gradient(270deg, #000, rgba(255,255,255,0))}#movie .banner .slide-mask-left[data-v-7c6f47cb]{background-image:linear-gradient(90deg, #000, rgba(255,255,255,0))}#movie .loading-article-card__title[data-v-7c6f47cb]{background-color:#181818}#movie .blogger-ranking__title .text[data-v-7c6f47cb]{color:#fff}\n", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
